<script>
  import * as THREE from "three";
  import { sum } from "d3";
  import { getContext } from "svelte";
  import viewport from "../stores/viewport.js";
  import { scrollZ, selectedAudience } from "../stores/global.js";
  import Moons from "./Universe.Moons.svelte";
  import audience from "../data/audience-props.json";

  export let planetGroup;
  export let data;

  let nearMesh,
    opacity = 1,
    percentage = 1;

  const { index, texture, spriteX, spriteY, spriteW, spriteH } = data;

  const { NEAR, FAR, RADIUS, DEPTH } = getContext("Universe");
  const RAD = [64, 16, 8];

  const planet = new THREE.Group();
  const lod = new THREE.LOD();
  const colorMap = [0xffffff, 0x333333, 0x555555];
  const factor = $viewport.width < 640 ? 0.3 : 1;
  const cr = factor * RADIUS;

  const setSprite = (mesh) => {
    const uvAttr = mesh.geometry.attributes.uv;

    for (let i = 0; i < uvAttr.count; i++) {
      let u = uvAttr.getX(i);
      let v = uvAttr.getY(i);

      // write values back to attribute
      u = u / spriteW + spriteX / spriteW;
      v = v / spriteH + (spriteH - 1 - spriteY) / spriteH;
      uvAttr.setXY(i, u, v);
    }
  };

  for (let i = 0; i < 3; i++) {
    // const geometry = geometries[i];
    const geometry = new THREE.CircleBufferGeometry(cr, RAD[i]);

    const material = new THREE.MeshLambertMaterial({
      color: colorMap[i],
      transparent: true,
      opacity: 1,
    });

    if (i < 2) material.map = texture;
    if (material.map) material.map.needsUpdate = true;

    const mesh = new THREE.Mesh(geometry, material);
    mesh.userData = { index };

    if (i === 0) nearMesh = mesh;

    setSprite(mesh);

    const level = NEAR + Math.floor((i / 3) * FAR);

    lod.addLevel(mesh, level);
  }

  planet.add(lod);
  planetGroup.add(planet);

  $: dist = DEPTH - $scrollZ - data.z;
  $: dist, (opacity = updateOpacity());

  const updateOpacity = () => {
    let opacity = 1;
    const tweenDist = 100;
    if (nearMesh) {
      if (dist > NEAR && dist < NEAR + tweenDist) {
        opacity = (dist - NEAR) / tweenDist;
        nearMesh.material.opacity = opacity;
      } else if (dist < NEAR) opacity = 0;
    }
    nearMesh.material.opacity = opacity;
    return opacity;
  };

  const updatePosition = (aspect) => {
    const factor = aspect < 1 ? 1 / aspect : 1;
    planet.position.set(x * aspect, y * aspect, z);
  };

  $: x = data.x;
  $: y = data.y;
  $: z = data.z;

  $: updatePosition($viewport.width / $viewport.height);

  $: {
    const match = audience.find((d) => d.name === $selectedAudience);
    if (!match) percentage = 0;
    else if (!data.hhi75) percentage = undefined;
    else {
      const val = data[match.col];
      if (val === "") percentage = 0;
      else percentage = +val / 100;
    }
  }
</script>

<Moons
  planet="{planet}"
  percentage="{percentage}"
  opacity="{opacity}"
  radius="{cr}"
  index="{index}"
/>

<div class="hidden-details">
  <h4>{data.title}</h4>
  <p>{data.description}</p>
</div>

<style>
  .hidden-details {
    display: none;
  }
</style>
